import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@material-ui/core';

import ProfileTitle from '../../layout/mobile/profile/ProfileTitle';

import contactUsList from './contactUsList';
import useStyles from './styles';

const ContactUs = (props) => {
  const { mobile } = props;
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <ProfileTitle
        mobile={mobile}
        subtitle="Aquí encontrarás nuestros canales de atención."
        title={<strong>Contáctanos</strong>}
      />
      <Box className={classes.contactUsDetail}>
        {contactUsList.map((element, key) => (
          <Grid
            key={key}
            container
            spacing={3}
            className={classes.contactBox}
            data-cy="contactUsElementInList"
          >
            <Grid item xs={2} md={1} className={classes.imgContainer}>
              <img src={element.src} />
            </Grid>
            <Grid item xs={10} md={11}>
              <div className={classes.contactBoxTitle}>{element.title}</div>
              <div className={classes.contactBoxSubtitle}>
                {element.subtitle}
              </div>
            </Grid>
          </Grid>
        ))}
      </Box>
    </Box>
  );
};

ContactUs.propTypes = {
  mobile: PropTypes.bool,
};

export default ContactUs;
